import { useMemo } from 'react';
import { useCallSourceData } from './use_call_source_data';
import { useCompanySettingsStore } from './use_global_context';

type CallRequeueHookReturn = { callRequeueEnabled: boolean };

/**
 * A helper hook to bring to sources of information validating the Call Requeue feature is properly enabled.
 * @returns an object with 'callRequeueEnabled' property validating from multiple sources that call requeue features is enabled
 * @example
 * {
 *    callRequeueEnabled: true
 * }
 */
export const useCallRequeue = (): CallRequeueHookReturn => {
    const { callSource } = useCallSourceData();
    const companySettingsStore = useCompanySettingsStore();

    return useMemo(() => {
        return {
            callRequeueEnabled:
                callSource != null
                    ? companySettingsStore.sourceSettingsDictionary[callSource.code]?.[
                          'CALL_REQUEUE_ENABLED'
                      ]?.value === 'true'
                    : false,
        };
    }, [companySettingsStore.sourceSettingsDictionary, callSource]);
};
